import config from '../config';

export const appointmentApi = {
  // Fetch all appointments for a midwife
  async getMidwifeAppointments(midwifeId) {
    const response = await fetch(`${config.api.url}/midwives/${midwifeId}/appointments`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('velaToken')}`,
      },
    });
    if (!response.ok) throw new Error('Failed to fetch appointments');
    return response.json();
  },

  // Fetch appointments for a specific client
  async getClientAppointments(clientId) {
    const response = await fetch(`${config.api.url}/clients/${clientId}/appointments`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('velaToken')}`,
      },
    });
    if (!response.ok) throw new Error('Failed to fetch client appointments');
    return response.json();
  },

  // Create a new appointment
  async createAppointment(appointmentData) {
    const response = await fetch(`${config.api.url}/appointments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('velaToken')}`,
      },
      body: JSON.stringify(appointmentData),
    });
    if (!response.ok) throw new Error('Failed to create appointment');
    return response.json();
  },

  // Update an existing appointment
  async updateAppointment(appointmentId, appointmentData) {
    const response = await fetch(`${config.api.url}/appointments/${appointmentId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('velaToken')}`,
      },
      body: JSON.stringify(appointmentData),
    });
    if (!response.ok) throw new Error('Failed to update appointment');
    return response.json();
  },

  // Delete an appointment
  async deleteAppointment(appointmentId) {
    const response = await fetch(`${config.api.url}/appointments/${appointmentId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('velaToken')}`,
      },
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'Failed to delete appointment');
    }

    // Only try to parse JSON if there's content
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json();
    }
    
    // Return null for empty responses
    return null;
  },

  // Get available time slots for a midwife
  async getAvailableTimeSlots(midwifeId, date) {
    const response = await fetch(
      `${config.api.url}/midwives/${midwifeId}/available-slots?date=${date}`,
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('velaToken')}`,
        },
      }
    );
    if (!response.ok) throw new Error('Failed to fetch available time slots');
    return response.json();
  },
}; 